import { transformAsCurrency, formatCurrencyAsTex3 } from '~/utils/functions';

export interface Produto {
  id?: number | string;
  val_custo_rep: number;
  val_custo_sem_icms: number;
}

export interface ItemCalcInput {
  qtdReceita: number;
  totQtdReceita: number;
  qtdRendimento: number;
  produtoAtual: Produto;
}

export interface ItemCalcResult {
  perParticipacao: number;
  qtdRendeKg: number;
  qtdProducao: number;
  custoFinal: number;
  custoSemImpostoFinal: number;
}

export function calcUnitario({
  qtdReceita,
  totQtdReceita,
  qtdRendimento,
  produtoAtual,
}: ItemCalcInput): ItemCalcResult {
  let perParticipacao = qtdReceita > 0 ? (qtdReceita / totQtdReceita) * 100 : 0;

  let qtdRendeKg =
    totQtdReceita > 0 && qtdRendimento > 0 ? totQtdReceita / qtdRendimento : 0;

  let qtdProducao =
    qtdRendeKg > 0 && perParticipacao > 0
      ? (qtdRendeKg * perParticipacao) / 100
      : 0;

  let custoFinal = 0;
  let custoSemImpostoFinal = 0;

  custoFinal += produtoAtual.val_custo_rep * qtdProducao;
  custoSemImpostoFinal += produtoAtual.val_custo_sem_icms * qtdProducao;

  // formata valores para levar em consideração apenas as 3 primeiras casas decimais
  perParticipacao = transformAsCurrency(formatCurrencyAsTex3(perParticipacao));
  qtdRendeKg = transformAsCurrency(formatCurrencyAsTex3(qtdRendeKg));
  qtdProducao = transformAsCurrency(formatCurrencyAsTex3(qtdProducao));

  return {
    perParticipacao,
    qtdRendeKg,
    qtdProducao,
    custoFinal,
    custoSemImpostoFinal,
  };
}
